import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './notification.types';

export const notificationSelectors = {
  ...generateResourceSelectors<types.INotification>((state) => state.resource.notification),
};
